// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.75 12.75C8.75 10.9551 10.2051 9.5 12 9.5C13.7949 9.5 15.25 10.9551 15.25 12.75C15.25 14.5449 13.7949 16 12 16C10.2051 16 8.75 14.5449 8.75 12.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.88197 2H16.118L17.618 5H23V21H1V5H6.38197L7.88197 2ZM6.75 12.75C6.75 15.6495 9.1005 18 12 18C14.8995 18 17.25 15.6495 17.25 12.75C17.25 9.8505 14.8995 7.5 12 7.5C9.1005 7.5 6.75 9.8505 6.75 12.75Z"}}]};

const CameraFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'camera-filled',
    ref,
    icon: element,
  },
));

CameraFilledIcon.displayName = 'CameraFilledIcon';

export default CameraFilledIcon;
